module.exports = __webpack_public_path__ + "img/icon_dialog_svip_level1.552ca674.png";